import { Outlet } from 'react-router-dom';

function FullPageLayout() {
	return (
		<main>
			<Outlet />
		</main>
	);
}

export default FullPageLayout;
